module.exports = __webpack_public_path__ + "img/multi_image07.5987e8b0.png";